import { get } from 'lodash';

/**
 * Custom sorting data accessor to have case insensitive sorting with trim and number conversion
 * @param {Object} dataSourceRow
 * @param {string} matColumnDef
 * @returns {string | number}
 */
export function sortingDataAccessor(dataSourceRow: object, matColumnDef: string): string | number {
    let value: string;

    const data = get(dataSourceRow, matColumnDef);
    // Break if source row is not found
    if (!data) {
        return '';
    }

    if (data instanceof Array) {
        // Default data as an array.
        value = data.length > 0 ? data.join(' ') : '|';
    } else {
        // Default data as a string
        value = data;
    }

    // Trim and convert to lower case
    value = value.trim().toLowerCase();

    // Return string or number to sort
    return isNaN(+value) ? value : +value;
}

// Custom Sorting data accessor to take into account communication types
export function commSortingDataAccessor(dataSourceRow: object, matColumnDef: string): string | number {
    const column = matColumnDef.trim().toLowerCase();
    switch (column) {
        case 'mso':
        case 'incident':
        case 'request':
        case 'patch':
        case 'change':
        case 'billing':
            // Break if source column is not found
            if (!dataSourceRow['communicationTypes']) {
                return '';
            }
            return -(dataSourceRow['communicationTypes'] as string[])
                .findIndex(comm => comm.toLowerCase() === column);
        default:
            return sortingDataAccessor(dataSourceRow, matColumnDef);
    }
}
